<div
  class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
  [ngClass]="{
    'ag-checked': params.value,
    'ag-disabled': isDisabled,
    'ag-indeterminate': params.value === null
  }"
>
  <input
    type="checkbox"
    [readOnly]="isDisabled"
    [disabled]="isDisabled"
    (change)="toggleHandler($event)"
    [checked]="params.value"
  />
</div>
